import {
  BATHROOM_CABINET_BOX_PART_IDS,
  CABINET_BOXES,
  KITCHEN_CABINET_BOX_PART_IDS,
  SHAPE_PART_ID,
} from "../constants";

export const MINIMUM_TALL_CABINET_HEIGHT = 61;

const getInitialCabinetHeight = (shape) => {
  return typeof shape.getInitialHeight === "function"
    ? shape.getInitialHeight()
    : shape.shapeParams && shape.shapeParams.height;
};

/**
 * Returns true when a shape is a tall cabinet, for both live shapes and
 * their exported SQFT-data representation.
 */
export const isShapeTallCabinet = (shape) => {
  if (!shape) {
    return false;
  }

  if (shape.partId === SHAPE_PART_ID.tall_cabinet) {
    return true;
  }

  return KITCHEN_CABINET_BOX_PART_IDS.includes(getCabinetBoxPartId(shape))
    && getInitialCabinetHeight(shape) > MINIMUM_TALL_CABINET_HEIGHT;
};

// Cabinet shapes can store the box part on either partId or parentPartId,
// depending on whether the shape came from a feature group or a box group.
export function getCabinetBoxPartId(shape) {
  if (!shape) {
    return null;
  }

  return [shape.partId, shape.parentPartId]
    .find(partId => CABINET_BOXES.includes(partId)) || null;
}

export function areKitchenCabinetBoxes(firstShape, secondShape) {
  return KITCHEN_CABINET_BOX_PART_IDS.includes(getCabinetBoxPartId(firstShape))
    && KITCHEN_CABINET_BOX_PART_IDS.includes(getCabinetBoxPartId(secondShape));
}

export function areBathroomCabinetBoxes(firstShape, secondShape) {
  return BATHROOM_CABINET_BOX_PART_IDS.includes(getCabinetBoxPartId(firstShape))
    && BATHROOM_CABINET_BOX_PART_IDS.includes(getCabinetBoxPartId(secondShape));
}

// Tall cabinets occupy both upper and lower cabinet lanes, so they can share
// shuffle/placement runs with either lane. Regular upper/lower cabinets cannot.
export function canCabinetBoxesShareRun(firstShape, secondShape) {
  if (areBathroomCabinetBoxes(firstShape, secondShape)) {
    return true;
  }

  if (!areKitchenCabinetBoxes(firstShape, secondShape)) {
    return false;
  }

  return getCabinetBoxPartId(firstShape) === getCabinetBoxPartId(secondShape)
    || isShapeTallCabinet(firstShape)
    || isShapeTallCabinet(secondShape);
}
